import React, { useState, useCallback, useEffect } from 'react';
import { FiXCircle } from 'react-icons/fi';
import { useParams, useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import getValidationErrors from '../../utils/getValidationErrors';

import { useToast } from '../../hooks/Toast';

import api from '../../services/api';

import Layout from '../../components/Layout';
import DefaultForm from '../../components/DefaultForm';

import { Container, FormContainer } from './styles';

import { Service } from '../../interfaces/Service';

const FormModal: React.FC = () => {
  const [data, setData] = useState<Service | null>();

  const history = useHistory();
  const { entity_id } = useParams<any>();

  const { addToast } = useToast();

  useEffect(() => {
    if (entity_id && entity_id !== 'novo') {
      api
        .get(`services/${entity_id}`)
        .then(response => {
          const dataAux = response.data.item;
          setData(dataAux);
        })
        .catch(err => {
          console.log(err);
          addToast({
            type: 'error',
            title: 'Falha na requisição',
            description:
              'Ocorreu um erro ao carregar os dados, verifique sua conexão e tente novamente.',
          });
        });
    }
  }, []);

  const sendForm = useCallback(
    async (data: Service) => {
      const isUpdate = entity_id && entity_id !== 'novo' ? true : false;

      try {
        let schema = Yup.object().shape({
          name: Yup.string().required('Nome obrigatório'),
          description: Yup.string().required('Descrição obrigatória'),
          value: Yup.string().required('Valor obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        let response;
        data.value = parseFloat(data.value);

        if (isUpdate) {
          response = await api.put(`services/${entity_id}`, data);
        } else {
          response = await api.post('services', data);
        }

        return ({ resp: true, message: response.data.success.message });
      } catch (err) {
        console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          return ({ resp: false, errors });
        } else {
          addToast({
            type: 'error',
            title: 'Falha na requisição',
            description:
              'Ocorreu um erro ao salvar, verifique os dados e tente novamente',
          });
        }
      }
    },
    [entity_id],
  );

  return (
    <Layout>
      <Container>
        <div className="breadcrumb">
          <h1>MDS &gt; Serviços &gt; {data ? data.name : 'Novo'}</h1>

          <button
            type="button"
            onClick={() => history.go(-1)}
            className="close-btn"
          >
            <FiXCircle />
          </button>
        </div>

        <FormContainer>
          <DefaultForm
            indexPath="/servicos"
            submitForm={(formData) => sendForm(formData)}
            currentData={data}
            entity="services"
            inputs={[
              {
                input_type: "Input",
                name: "name",
                label: "Nome",
                fullWidth: true,
              },
              {
                input_type: "MoneyInput",
                name: "value",
                label: "Valor",
                fullWidth: true,
              },
              {
                input_type: "Textarea",
                name: "description",
                label: "Descrição",
                fullWidth: true,
              },
            ]}
          />
        </FormContainer>

      </Container>
    </Layout>
  );
};

export default FormModal;
